import { MesaCardImage } from '@/src/common/modules/CardSection'
import { DesignSystem } from '@/src/design-system'
import { H4, Paragraph, View, YStack } from 'tamagui'
import { Link } from 'expo-router'
import { Button } from '@/src/common/components/Button'

export function GetTheCard() {
  return (
    <DesignSystem.SplitCard>
      <DesignSystem.SplitCard.Header>
        <View p="$4" items="center" justify="center">
          <MesaCardImage />
        </View>
      </DesignSystem.SplitCard.Header>
      <DesignSystem.SplitCard.Content>
        <YStack gap="$4">
          <H4>Get rewarded for being a homeowner</H4>
          <Paragraph>
            Earn rewards on your mortgage payments, home improvements, and everyday purchases.
            Redeem for home upgrades, vacations, and more — just for being a homeowner. Terms Apply.
          </Paragraph>
          <View py="$2">
            <Link href="/main/card/cardBenefits" asChild push>
              <Button
                segmentAction='User Pressed the "Card Benefits" card component'
                title="Learn More"
                size="sm"
              />
            </Link>
          </View>
        </YStack>
      </DesignSystem.SplitCard.Content>
    </DesignSystem.SplitCard>
  )
}
